import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Query, Req } from '@nestjs/common';
import { ApiHeader, ApiQuery, ApiTags } from '@nestjs/swagger';
import { WelfarestatusupdateResponseModel, WelfareupdatestatusResponseModel } from '../welfare/dto/welfare-response-model';
import { GetWelfarestatusDTO, WelfareidstatusDTO } from '../welfare/dto/welfare.dto';
import { WelfarestatusService } from './welfarestatus.service';
@ApiTags('welfarestatus')
@Controller('welfarestatus')
export class WelfarestatusController {
    constructor(
        private WelfarestatusService: WelfarestatusService
    ){}

      @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
})  
  @Post('/update/Welfare/welfarestatus')
  @ApiQuery({name:'apiVersion'})
async updateWelfarestatus(@Query() queryParams,@Body() WelfareidstatusDTO:WelfareidstatusDTO,@Req() request:Request): Promise<WelfareupdatestatusResponseModel> {
  try {
    return await this.WelfarestatusService.updateWelfarestatus(queryParams,WelfareidstatusDTO, request);
  } catch (error) {
    return errorHandler(WelfareupdatestatusResponseModel, error);
  }
}
@ApiHeader({
    name:'Authorization',
    description:'Authorization token'
})  
  @Post('/getAllWelfarestatus')
  @ApiQuery({name:'apiVersion'})
  async getAllWelfarestatus(@Query() queryParams, @Req() request: Request): Promise<WelfareupdatestatusResponseModel> {
    try {
      return await this.WelfarestatusService.getAllWelfarestatus(queryParams, request);
    } catch (error) {
      return errorHandler(WelfareupdatestatusResponseModel, error);
    }
  }
  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
})  
  @Post('/getWelfarestatusByWelfareId')
  @ApiQuery({name:'apiVersion'})
  async getWelfareByWelfarestatusId(@Query() queryParams, @Body() GetWelfarestatusDTO: GetWelfarestatusDTO, @Req() request:Request): Promise<WelfarestatusupdateResponseModel> {
    try {
      return await this.WelfarestatusService.getWelfareByWelfarestatusId(queryParams,GetWelfarestatusDTO.welfareStatusId,request);
    } catch (error) {
      return errorHandler(WelfarestatusupdateResponseModel, error);
    }
  }

}
